import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const CircleHalfFilled = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M1 8C1 4.13401 4.13401 1 8 1C8.4675 1 8.92429 1.04583 9.36613 1.13324L9.07503 2.60472C8.72854 2.53617 8.36924 2.5 8 2.5V13.5C8.36924 13.5 8.72854 13.4638 9.07503 13.3953L9.36613 14.8668C8.92429 14.9542 8.4675 15 8 15C4.13401 15 1 11.866 1 8Z"
      fill="currentColor"
    />
    <path
      d="M14.8668 9.36613L13.3953 9.07503C13.4638 8.72854 13.5 8.36924 13.5 8C13.5 7.63076 13.4638 7.27146 13.3953 6.92497L14.8668 6.63387C14.9542 7.07571 15 7.5325 15 8C15 8.4675 14.9542 8.92429 14.8668 9.36613Z"
      fill="currentColor"
    />
    <path
      d="M12.5745 4.94517L13.821 4.11069C13.3099 3.34733 12.6527 2.6901 11.8893 2.17904L11.0548 3.42549C11.6553 3.82747 12.1725 4.34474 12.5745 4.94517Z"
      fill="currentColor"
    />
    <path
      d="M11.8893 13.821L11.0548 12.5745C11.6553 12.1725 12.1725 11.6553 12.5745 11.0548L13.821 11.8893C13.3099 12.6527 12.6527 13.3099 11.8893 13.821Z"
      fill="currentColor"
    />
  </Icon>
));

export default CircleHalfFilled;
